import calculateStep from './calculate-step';

const calculateMinMax = (filterAggregations, rangeInterval) => {
  let { min, max } = filterAggregations;
  min = Math.floor(Number(min));
  max = Math.ceil(Number(max));
  min -= min % rangeInterval;
  const step = calculateStep(max, rangeInterval);
  max += step;
  return { min, max };
};

export default calculateMinMax;
